/* eslint-disable max-len */
/* eslint-disable camelcase */
/* eslint-disable no-param-reassign */
import { RendererFactory } from 'survey-vue';
import Vue from 'vue';
import { createPage, createFlow } from '../utils';
import { MALE } from '../../gender';
import i18n from '../../../plugins/i18n';
import { REPEAT } from '../variables';
import { NODE_ENV } from '../../env';
import {
  FIRST_NAME,
  LAST_NAME,
  DATE_OF_BIRTH,
  GENDER,
  PRIMARY_COMPLAINT,
  IS_RETURNING_PATIENT,
} from '../../store';
import SemaglutideOption from '../../../components/Truforme/SemaglutideOption.vue';
import GlpMedicationOption from '../../../components/Truforme/GLPMedicationOption.vue';

Vue.component('semaglutide-option', SemaglutideOption);
Vue.component('glp-medication-option', GlpMedicationOption);
RendererFactory.Instance.registerRenderer(
  'radiogroup', // The question type
  'semaglutide-option-renderer', // A unique renderer name
  'semaglutide-option' // The name of your Vue component
);
RendererFactory.Instance.registerRenderer(
  'radiogroup', // The question type
  'glp-option-renderer', // A unique renderer name
  'glp-medication-option' // The name of your Vue component
);

function isIneligible(survey) {
  const ineligibleQuestion = survey.getQuestionByName('IS_INELIGIBLE');
  if (!ineligibleQuestion) console.warn('IS_INELIGIBLE not found');
  return ineligibleQuestion?.value;
}

const TruformeLanding = createPage({
  name: 'TruformeLanding',
  nextPage: 'TruformeNewReturning',
  options: {
    showFooter: true,

    hideHeader: false,
    pageConfig: {
      init: (store, _, vm) => {
        const { surveyAnswers } = store.state.registration;
        const { suicide } = surveyAnswers;
        if (suicide === 'Yes') {
          vm.$set(vm, 'breakupText', 'Sympathy');
        }
      },
    },
  },
});

const TruformeIneligible = createPage({
  name: 'TruformeIneligible',
  nextPage: 'RegisterLogout',
  options: {
    showFooter: false,

    hideHeader: false,
    pageConfig: {
      init: (store, _, vm) => {
        const { surveyAnswers } = store.state.registration;
        const { suicide } = surveyAnswers;
        if (suicide === 'Yes') {
          vm.$set(vm, 'breakupText', 'Sympathy');
        }
      },
    },
  },
});

const TruformeNewReturning = createPage({
  name: 'TruformeNewReturning',
  nextPage: 'RegisterIntroduce',
  options: {
    showFooter: true,
    hideHeader: false,
    pageConfig: {
      pageTitle: 'Is this your first visit for weight loss, or a follow-up?',
      buttonTextNew: 'First visit',
      buttonTextReturning: 'Follow-up',
    },
  },
});

const RegisterSurvey = createPage({
  name: 'RegisterSurvey',
  nextPage: (state) => {
    if (state.registration.ineligible) {
      return 'TruformeIneligible';
    }
    return 'TruformeComplete';
  },
  options: {
    backButtonHeader: true,
    showFooter: false,
    pageConfig: {
      pageTitle: 'Please complete a brief intake',
      showFooter: false,
      pageSubtitle: '',
      showTitle: false,
      showSubtitle: false,
      onSurveyCreate: (state, survey, store) => {
        store.commit('setRegistration', {
          ineligible: false,
        });
        survey.data = {
          ...survey.data,
          firstName: FIRST_NAME(state),
          lastName: LAST_NAME(state),
          gender: GENDER(state),
          primaryComplaint: PRIMARY_COMPLAINT(state),
          dateOfBirth: DATE_OF_BIRTH(state),
          ...state.registration.surveyAnswers,
        };

        survey.showTitle = false;
        survey.getAllQuestions().forEach((q) => {
          if (q.name !== 'rx_choice_detail') return;
          q.renderAs = 'semaglutide-option-renderer';
        });
        survey.getAllQuestions().forEach((q) => {
          if (q.name !== 'current_medication') return;
          q.renderAs = 'glp-option-renderer';
        });

        survey.onValueChanged.add((s) => {
          store.commit('setRegistration', {
            surveyAnswers: s.data,
          });
        });

        function eligibilityCheck(s) {
          const ineligible = isIneligible(s);

          if (ineligible) {
            if (store.state.registration.ineligible) return;
            store.commit('setRegistration', {
              ineligible: true,
            });
            setTimeout(() => {
              window.dispatchEvent(new CustomEvent('GO_NEXT_PAGE'));
            }, 0);
          }
        }

        survey.onComplete.add((s) => {
          eligibilityCheck(s);
        });
        survey.onCurrentPageChanged.add((s) => {
          eligibilityCheck(s);
        });
      },
      init: async (store) => {
        const tenantUrl = store.state.registration.tenantUrl || localStorage.tenantUrl;
        const forms = {
          development: {
            demo: {
              new: 'p_ydu6FdZJS8IoYsuMar9i',
              returning: 'p_jglZzHDePZ8piqW8jxwI',
            },
          },
          production: {
            'sentry-health': {
              new: 'p_nrjXUsqcby7n1JAS0IFH',
              returning: 'p_dqbAGkpWzZ3FdhjuBLFX',
            },
          },
        };
        if (IS_RETURNING_PATIENT(store.state)) {
          const nodeForm = forms[NODE_ENV] || {};
          const tenantForm = nodeForm[tenantUrl];
          if (!tenantForm) return;
          await store.commit('setRegistration', { form: tenantForm?.returning || '' });
        } else {
          const nodeForm = forms[NODE_ENV] || {};
          const tenantForm = nodeForm[tenantUrl];
          if (!tenantForm) return;
          await store.commit('setRegistration', { form: tenantForm?.new || '' });
        }
      },
    },
  },
});

const RegisterIntroduce = createPage({
  name: 'RegisterIntroduce',
  nextPage: 'RegisterSurvey',
  options: {
    pageConfig: {
      healthCardExpiryOptional: true,
      healthCardNumberOptional: true,
      healthCardVersionOptional: true,
      isAddressOptional: false,
      isEmailOptional: false,
      showGender: false,
      showEmail: true,
      showAddress: true,
      hideHeader: true,
      showHeader: false,
      checkForExistingUser: false,
      // pageTitle: 'Please, tell us a bit about yourself',
      patientData: {
        gender: MALE,
      },
      init: (store) => {
        const { surveyAnswers } = store.state.registration;
        const { sex } = surveyAnswers;
        store.commit('setPatientData', { gender: sex });
      },
    },
  },
});

const TruformeComplete = createPage({
  name: 'TruformeComplete',
  nextPage: 'TruformeCreateInvoice',
  options: {
    showFooter: false,
    pageConfig: {
      showFooter: false,
      checkForExistingUser: true,
      loadingText: 'This will only take a moment...',
      loadingTitleText: 'Finishing up...',
      buttonText: i18n.t('main.continue'),
      cardText: i18n.t('registration.TruformeComplete.truforme.cardText'),
      cardTitle: i18n.t('registration.TruformeComplete.truforme.cardTitle'),
      clickToContinue: true,
      isEndOfRegistration: false,
    },
  },
});

const TruformeCreateInvoice = createPage({
  name: 'TruformeCreateInvoice',
  nextPage: 'TruformePayInvoice',
  options: {
    showFooter: false,
    pageConfig: {
      showFooter: true,
    },
  },
});
const TruformePayInvoice = createPage({
  name: 'TruformePayInvoice',
  nextPage: 'TruformeGeneratePrescription',
  options: {
    showFooter: false,
    pageConfig: {
      showFooter: true,
    },
  },
});
const TruformeGeneratePrescription = createPage({
  name: 'TruformeGeneratePrescription',
  nextPage: 'TruformeEnd',
  options: {
    showFooter: false,
    pageConfig: {
      createLabReq: true,
      showFooter: true,
      init: async (store, route, vm) => {
        if (IS_RETURNING_PATIENT(store.state)) return;
        vm.$set(vm, 'createPrescription', true);
        vm.$set(vm, 'createLabReq', true);
      },
    },
  },
});
const TruformeEnd = createPage({
  name: 'TruformeEnd',
  nextPage: 'RegisterLogout',
  options: {
    showFooter: false,
    pageConfig: {
      showFooter: false,
    },
  },
});

const RegisterLogout = createPage({
  name: 'RegisterLogout',
  nextPage: REPEAT,
  options: {
    clearHistory: true,
  },
});

const truforme = createFlow({
  // landing: 'TruformeIneligible',
  landing: 'TruformeEnd',
  theme: 'truforme',
  customLogo: '/HERERX.png',
  onError: 'RegisterIntroduce',
  flow: {
    TruformeNewReturning,
    RegisterIntroduce,
    RegisterSurvey,
    TruformeComplete,
    TruformeIneligible,
    TruformeEnd,
    RegisterLogout,
    TruformeLanding,
    TruformeCreateInvoice,
    TruformePayInvoice,
    TruformeGeneratePrescription,
  },
});

export default truforme;
